import { reportService } from '../../helpers/services/report.service'
import { sharedHelper } from '@/utils'

export const state = {
  salesSummary: null,
  topDebtors: [],
  monthlyTrend: [],
  weeklyTrend: [],
  salesByAgent: [],
  salesByProduct: [],
  salesByClientGroup: [],
  stockBuffer: [],
  stockMovement: null,
  marketStock: [],
  agentStock: [],
  agentStockDetail: null,
  recentSalesDocs: [],
  status: { loading: true },
}

export const REPORT_MODULE = 'report'

export const GET_SALES_SUMMARY = 'getSalesSummary'
export const GET_TOP_DEBTORS = 'getTopDebtors'
export const GET_MONTHLY_TREND = 'getMonthlyTrend'
export const GET_WEEKLY_TREND = 'getWeeklyTrend'
export const GET_SALES_BY_AGENT = 'getSalesByAgent'
export const GET_SALES_BY_PRODUCT = 'getSalesByProduct'
export const GET_SALES_BY_CLIENT_GROUP = 'getSalesByClientGroup'
export const GET_STOCK_BUFFER = 'getStockBuffer'
export const GET_STOCK_MOVEMENT = 'getStockMovement'
export const GET_MARKET_STOCK = 'getMarketStock'
export const GET_AGENT_STOCK = 'getAgentStock'
export const GET_AGENT_STOCK_DETAIL = 'getAgentStockDetail'
export const GET_RECENT_SALES_DOCS = 'getRecentSalesDocs'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const M_SALES_SUMMARY = 'mSalesSummary'
const M_TOP_DEBTORS = 'mTopDebtors'
const M_MONTHLY_TREND = 'mMonthlyTrend'
const M_WEEKLY_TREND = 'mWeeklyTrend'
const M_SALES_BY_AGENT = 'mSalesByAgent'
const M_SALES_BY_PRODUCT = 'mSalesByProduct'
const M_SALES_BY_CLIENT_GROUP = 'mSalesByClientGroup'
const M_STOCK_BUFFER = 'mStockBuffer'
const M_STOCK_MOVEMENT = 'mStockMovement'
const M_MARKET_STOCK = 'mMarketStock'
const M_AGENT_STOCK = 'mAgentStock'
const M_AGENT_STOCK_DETAIL = 'mAgentStockDetail'
const M_RECENT_DOCS = 'mRecentDocs'

function reportAction(serviceFn, mutationName) {
  return ({ commit }, { filter } = {}) => {
    commit(REQUESTING, 'loading')
    return serviceFn(filter || {}).then((r) => {
      commit(mutationName, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  }
}

export const actions = {
  [GET_SALES_SUMMARY]: reportAction(reportService.getSalesSummary, M_SALES_SUMMARY),
  [GET_TOP_DEBTORS]: reportAction(reportService.getTopDebtors, M_TOP_DEBTORS),
  [GET_MONTHLY_TREND]: reportAction(reportService.getMonthlyTrend, M_MONTHLY_TREND),
  [GET_WEEKLY_TREND]: reportAction(reportService.getWeeklyTrend, M_WEEKLY_TREND),
  [GET_SALES_BY_AGENT]: reportAction(reportService.getSalesByAgent, M_SALES_BY_AGENT),
  [GET_SALES_BY_PRODUCT]: reportAction(reportService.getSalesByProduct, M_SALES_BY_PRODUCT),
  [GET_SALES_BY_CLIENT_GROUP]: reportAction(reportService.getSalesByClientGroup, M_SALES_BY_CLIENT_GROUP),
  [GET_STOCK_BUFFER]: reportAction(reportService.getStockBuffer, M_STOCK_BUFFER),
  [GET_STOCK_MOVEMENT]: reportAction(reportService.getStockMovement, M_STOCK_MOVEMENT),
  [GET_MARKET_STOCK]: reportAction(reportService.getMarketStock, M_MARKET_STOCK),
  [GET_AGENT_STOCK]: reportAction(reportService.getAgentStock, M_AGENT_STOCK),
  [GET_AGENT_STOCK_DETAIL]({ commit }, { locationCode }) {
    commit(REQUESTING, 'loading')
    return reportService.getAgentStockDetail(locationCode).then((r) => {
      commit(M_AGENT_STOCK_DETAIL, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_RECENT_SALES_DOCS]: reportAction(reportService.getRecentSalesDocs, M_RECENT_DOCS),
}

export const mutations = {
  [M_SALES_SUMMARY](state, data) { state.salesSummary = data.data || null },
  [M_TOP_DEBTORS](state, data) { state.topDebtors = data.data || [] },
  [M_MONTHLY_TREND](state, data) { state.monthlyTrend = data.data || [] },
  [M_WEEKLY_TREND](state, data) { state.weeklyTrend = data.data || [] },
  [M_SALES_BY_AGENT](state, data) { state.salesByAgent = data.data || [] },
  [M_SALES_BY_PRODUCT](state, data) { state.salesByProduct = data.data || [] },
  [M_SALES_BY_CLIENT_GROUP](state, data) { state.salesByClientGroup = data.data || [] },
  [M_STOCK_BUFFER](state, data) { state.stockBuffer = data.data || [] },
  [M_STOCK_MOVEMENT](state, data) { state.stockMovement = data.data || null },
  [M_MARKET_STOCK](state, data) { state.marketStock = data.data || [] },
  [M_AGENT_STOCK](state, data) { state.agentStock = data.data || [] },
  [M_AGENT_STOCK_DETAIL](state, data) { state.agentStockDetail = data.data || null },
  [M_RECENT_DOCS](state, data) { state.recentSalesDocs = data.data || [] },
  [FAILURE](state) { state.status = { loading: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { loading: true } },
}
